import React from 'react';
import { capitalize } from 'lodash';
import { ErrorMessage } from 'formik';

const FormLabel = ({ name, label = capitalize(name), children }) => (
  <label style={{ display: 'flex', flexDirection: 'column' }} htmlFor={name}>
    {label}
    {children}

    <span style={{ color: 'red' }}>
      <ErrorMessage name={name} />
    </span>
  </label>
);

export default FormLabel
